import cookies from 'js-cookie'
let mayiDomain = process.env.VUE_APP_MAYI_DOMAIN
let cookieConfig = {
  userId: mayiDomain + '_PortalContext_UserId',
  userToken: mayiDomain + '_PortalContext_UserToken',
  isClient: 'isclient',
  groupGuid: mayiDomain + '_PortalContext_groupGuid',
  storeGuid: mayiDomain + '_PortalContext_storeGuid',
  startDate: mayiDomain + '_MobileContext_StartDate',
  endDate: mayiDomain + '_MobileContext_EndDate'
}

function setCookieByDomain(key, value, expires = 0) {
  cookies.set(key, value, { domain: mayiDomain, expires })
}

function getUserId() {
  return cookies.get(cookieConfig.userId)
}

function setUserId(userId) {
  setCookieByDomain(cookieConfig.userId, userId, 7)
}

function getUserToken() {
  return cookies.get(cookieConfig.userToken)
}

function setUserToken(userToken) {
  setCookieByDomain(cookieConfig.userToken, userToken, 7)
}

function getStartDate() {
  return cookies.get(cookieConfig.startDate)
}

export function setStartDate(dateStr) {
  setCookieByDomain(cookieConfig.startDate, dateStr, 7)
}

function getEndDate() {
  return cookies.get(cookieConfig.endDate)
}
export function setEndDate(dateStr) {
  setCookieByDomain(cookieConfig.endDate, dateStr, 7)
}

function getCheckDate() {
  let beginDateStr = getStartDate()
  let endDateStr = getEndDate()
  let today = Date.today()
  let tomorrow = Date.today().addDays(1)
  let beginDate = beginDateStr ? Date.getFormatDate(beginDateStr) : today
  let endDate = endDateStr ? Date.getFormatDate(endDateStr) : tomorrow
  let isSaveDate = false
  if (!beginDateStr || Date.compare(beginDate, today) < 0) {
    beginDate = today
    isSaveDate = true
  }
  if (!endDateStr || Date.compare(endDate, tomorrow) < 0) {
    endDate = tomorrow
    isSaveDate = true
  }
  if (isSaveDate) {
    setCheckDate(beginDate, endDate)
  }
  return {
    beginDate,
    endDate
  }
}

function setCheckDate(beginDate, endDate) {
  setStartDate(beginDate.toString('yyyy-MM-dd'))
  setEndDate(endDate.toString('yyyy-MM-dd'))
}

let mayiCookie = {
  getUserId,
  setUserId,
  getUserToken,
  setUserToken,
  setCookieByDomain,
  getStartDate,
  getEndDate,
  setStartDate,
  setEndDate,
  getCheckDate,
  setCheckDate
}

mayiCookie.setGroupGuid = (groupGuid) => {
  setCookieByDomain(cookieConfig.groupGuid, groupGuid, 7)
}

mayiCookie.getGroupGuid = () => {
  return cookies.get(cookieConfig.groupGuid)
}

mayiCookie.setStoreGuid = (storeGuid) => {
  setCookieByDomain(cookieConfig.storeGuid, storeGuid, 7)
}

mayiCookie.getStoreGuid = () => {
  return cookies.get(cookieConfig.storeGuid)
}

export default mayiCookie
